import React, { useState, useEffect, useContext } from 'react';
import {
  FaTrophy,
  FaMusic,
  FaMapMarkerAlt,
  FaClock,
  FaRunning,
  FaPaintBrush,
  FaStar,
  FaFireAlt
} from 'react-icons/fa';
import axios from 'axios';
import { AppContext } from '../../context/Appcontext';
import '../../assests/css/students/eventpage/eventschdule.css';

// Rotate through these icons/colors for each event card (since backend doesn't send icons)
const iconPool = [FaTrophy, FaRunning, FaMusic, FaPaintBrush, FaFireAlt, FaStar];
const colorPool = ["#6A88CE", "#E4916D", "#D1CFE3", "#8FBF9F", "#C98BA8", "#E0C36A"];

const Eventschdule = () => {
  const { baseUrl } = useContext(AppContext);
  const [activeDay, setActiveDay] = useState(1);
  const [scheduleData, setScheduleData] = useState([]);

  const fetchSchedule = () => {
    axios
      .get(`${baseUrl}/admin/events/viewAllEvents`)
      .then((response) => {
        const events = response.data.events || [];

        const formatted = events.map((event, index) => {
          // schedule kabhi string ki form mein aa sakta hai, isliye safely parse karo
          let parsedSchedule = event.schedule;
          if (typeof parsedSchedule === 'string') {
            try {
              parsedSchedule = JSON.parse(parsedSchedule);
            } catch (e) {
              parsedSchedule = [];
            }
          }
          if (!Array.isArray(parsedSchedule)) parsedSchedule = [];

          return {
            day: index + 1,
            number: String(index + 1).padStart(2, '0'),
            title: event.hero_title || event.card_title || `Event ${index + 1}`,
            date: event.hero_date || '—',
            location: event.card_venue || '—',
            time: parsedSchedule[0]?.time || '',
            color: colorPool[index % colorPool.length],
            events: parsedSchedule.map((item, i) => ({
              icon: iconPool[i % iconPool.length],
              name: item.activity || '',
              time: item.time || '',
            })),
          };
        });

        setScheduleData(formatted);
        if (formatted.length) setActiveDay(formatted[0].day);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchSchedule();
  }, []);

  if (scheduleData.length === 0) {
    return null; // ya loading state daal saktay hain
  }

  return (
    <div className="schedule-subscreen">
      {/* Header */}
      <div className="subscreen-header">
        <h1 className="header-title">Event Schedule</h1>
        <p className="header-subtitle">Three days of non-stop action and celebration</p>
      </div>

      {/* Schedule Cards */}
      <div className="schedule-cards-container">
        {scheduleData.map((schedule, index) => (
          <div
            key={schedule.day}
            className={`schedule-card ${activeDay === schedule.day ? 'active' : ''}`}
            onClick={() => setActiveDay(schedule.day)}
            style={{
              animationDelay: `${index * 0.15}s`,
              borderLeftColor: schedule.color
            }}
          >
            <div className="card-header-section">
              <div className="day-number" style={{ color: schedule.color }}>
                {schedule.number}
              </div>
              <div className="card-header-content">
                <h3 className="schedule-title">{schedule.title}</h3>
                <div className="schedule-meta">
                  <span className="meta-date" style={{ color: schedule.color }}>
                    {schedule.date}
                  </span>
                  <span className="meta-location">
                    <FaMapMarkerAlt /> {schedule.location} • {schedule.time}
                  </span>
                </div>
              </div>
            </div>

            {/* Events List */}
            <div className={`events-container ${activeDay === schedule.day ? 'expanded' : ''}`}>
              {schedule.events.length === 0 && (
                <p style={{ opacity: 0.7 }}>No schedule items added yet.</p>
              )}
              {schedule.events.map((event, idx) => {
                const IconComponent = event.icon;
                return (
                  <div
                    key={idx}
                    className="event-row"
                    style={{ animationDelay: `${idx * 0.1}s` }}
                  >
                    <div className="event-icon-wrapper" style={{ color: schedule.color }}>
                      <IconComponent />
                    </div>
                    <div className="event-info">
                      <span className="event-name">{event.name}</span>
                      <span className="event-time">
                        <FaClock /> {event.time}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>

      {/* Decorative Elements */}
      <div className="decorative-shapes">
        <div className="shape-circle shape-1"></div>
        <div className="shape-circle shape-2"></div>
        <div className="shape-circle shape-3"></div>
      </div>
    </div>
  );
};

export default Eventschdule;